<template>
  <div class="main">
    <div class="box">
<!--      <div class="img"><img src="../../assets/img.png" alt="图片"></div>-->
      <div class="tab-contain">
        <!-- tab栏 -->
        <ul id="tabs">
          <li v-for="(tab,index) in dataArr" :key="index" @click="switchTab(index)" class="topLi"
              :class="current===index?'current':''">
            <p><span>
              {{ getLabelByValue(editionOptions, tab.edition) }}
            </span>
<!--              <span>-->
<!--              {{ getLabelByValue(patternOptions, tab.list[0].pattern) }}-->
<!--            </span>-->
            </p>
          </li>
        </ul>
        <!-- 对应显示内容 -->
        <ul class="content">
          <li v-for="(item,index) in dataArr[current].list" :key="item.price" class="botLi"
              :class="currentLi=== index ? 'li-active' : ''"
              @click="selLi(index)">
            <div class="price">{{ item.price }}</div>
            <div class="rightBox">
              <p class="date"><span class="pr-2">{{ getDateValue(item) }}</span>原价￥{{ Number(item.price) * 3 / 2 }}
              </p>
              <p>{{ item.sub_heading }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="buy_money" v-show="isPay"><span>支付金额：</span><span>￥</span><span id="price">{{
          product.price
        }}</span></div>
      <div class="buy_money" v-show="!isPay">续费请选择相同版本会员!</div>
      <div class="sh_btn_box">
<!--        <b-button block class="mb-2 col-6" variant="primary" @click="pay('alipay')">支付宝支付</b-button>-->
        <b-button block class="mb-2 col-6" variant="primary" @click="pay('alipay2')">支付宝支付</b-button>
        <b-button class="mb-2 col-6" variant="primary" @click="pay('wxpay2')">微信二维码支付</b-button>
      </div>
      <p class="or_tips" style="color:#cccccc;max-width:80%;margin:20px auto;text-align: center;"><span>如您需要升级或降级产品可注册新账户进行订购或等待账户当前账期结束再进行升级或降级。<br></span>
      </p>
      <p class="or_tips" style="max-width:80%;margin:20px auto;text-align: center;color:#ee696c;"><span>支付成功后，账号和密码会通过邮件发送到您的邮箱。<br><b>{{
          userData.email
        }}</b></span>
      </p>
      <footerPage></footerPage>
      <el-dialog
          :title="qrtitle"
          :visible.sync="dialogVisible"
          width="250px"
          :show-close="false"
          center
          @opened="opened"
          @closed="closed"
          :before-close="handleClose">
        <div style="width: 100%;height: 200px">
          <div id="qrcode" ref="qrcode" style="margin: 0 auto"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import footerPage from '@/components/userInfo/footer'
import Qrcode from "qrcodejs2";
import qs from "qs";
import {getToken, getUser, getUserId} from "@/axios/token";

export default {
  name: "moneyPage",
  components: {footerPage},
  data() {
    return {
      qrtitle: '手机微信扫码付款',
      // 判断用户会员是否过期
      isHuiYuan: false,
      // 是否满足生成订单条件
      isPay: true,
      //版本类型
      editionOptions: [
        {label: '4K视频不限速版', value: 2},
        {label: 'Pro专业版', value: 3}
      ],
      //时间
      typeOptions: [
        {label: '30', value: 1},
        {label: '90', value: 2},
        {label: '180', value: 3},
        {label: '365', value: 4}
      ],
      //模式
      patternOptions: [
        {label: '单设备', value: 'Single'},
        {label: '双设备', value: 'Double'},
        {label: '多设备', value: 'Many'},
      ],
      dialogVisible: false,
      current: 0,
      currentLi: 0,
      dataArr: [
        {
          tab: '',
          list: [{pattern: ''}]
        },
        {
          tab: '',
          list: [{pattern: ''}]
        }
      ],
      tabs: [],
      product: {},
      codeUrl: '',
      user_id: parseInt(getUserId()),
      userData: {},
      pollingInterval: null,
      order_id: '',
      orderStatus: 0
    }
  },
  computed: {
    // 是否满足生成订单条件

  },
  watch: {
    current: {
      handler(n) {
        if (this.isHuiYuan && n === (this.userData.edition - 2) || !this.isHuiYuan) {
          this.isPay = true
        } else {
          this.isPay = false
        }
        console.log(this.isPay)
      },
      immediate: true
    }
  },
  methods: {
    getLabelByValue(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === value) {
          return arr[i].label;
        }
      }

      return null; // 如果未找到对应的label，则返回null或其他适合的默认值
    },
    //切换tab edition
    switchTab(index) {
      this.current = index
      // if (this.isHuiYuan && edition !== this.userData.edition) {
      //   this.currentLi = -1
      //   this.product.id = 0
      //   this.product.price = 0
      // } else {
        this.selLi(0)
      // }
    },
    //选择某个版本的某个li
    selLi(i) {
      if (this.isHuiYuan && this.current !== (this.userData.edition - 2) && this.userData.edition !== 0) return this.$message({
        message: "续费请选择相同版本会员!"
      })
      console.log(1)
      this.currentLi = i
      this.product = JSON.parse(JSON.stringify(this.dataArr[this.current].list[this.currentLi]))
    },
    getDateValue(item) {
      for (let i = 0; i < this.typeOptions.length; i++) {
        if (this.typeOptions[i].value === item.type) {
          let date = this.typeOptions[i].label;
          return `${date}天+送${item.effective_time - Number(date)}天 共${item.effective_time}天`
        }
      }
      return null; // 如果未找到对应的label，则返回null或其他适合的默认值
    },
    checkOrderStatus() {
      let data = {
        order_id: this.order_id
      };
      this.axios.post('/order/check', qs.stringify(data))
          .then((resp) => {
            this.orderStatus = resp.data.data.pay_status;
            if (this.orderStatus === 1) {
              this.$message({
                message: '支付成功',
                type: "success"
              })
              this.dialogVisible = false;
              clearInterval(this.pollingInterval);
            } else if (this.timeout <= 0) {
              clearInterval(this.pollingInterval);
            }
            this.timeout -= 2000; // 每2秒减少超时时间
          });
    },
    pay(method) {
      if (!this.isPay) return this.$message({
        type: "error",
        message: '请选择商品后再支付!'
      })
      switch (method) {
        case 'wxpay':
        case 'wxpay2':{
          this.qrtitle = '手机微信扫码付款';
          break;
        }
        case 'alipay':
        case 'alipay2': {
          this.qrtitle = '手机支付宝扫码付款';
          break;
        }
        case 'qqpay': {
          this.qrtitle = '手机qq扫码付款';
          break;
        }
      }
      let ismobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      let data = {
        //mode 1 默认 易支付
        //mode 2 支付宝走 易支付 微信走 官网二维码
        //mode 3 支付宝走 官网二维码 微信走易支付
        //mode 4 支付宝走 官网二维码 微信走 官网二维码
        //mode 5 支付宝走 官网h5 微信走 官网二维码
        mode: this.common.paymode,
        payment_method: method,
        user_id: this.user_id,
        payed_amount: this.product.price,
        order_amount: this.product.price,
        memo: '',
        object_id: this.product.id,
        delivery_address: '',
        delivery_name: '',
        phone: '',
        num: 1,
        is_mobile: ismobile ? 1: 0,
      }

      this.axios.post('/order/new', data, this.common.configjson).then((resp) => {
        let rdata = JSON.parse(resp.data.data.datas);
        this.order_id = resp.data.data.order_id;
        let qrcode = rdata.qrcode;
        if(data.mode === 4 && method == "alipay2"){
          window.location.href = qrcode;
        } else {
          if (!qrcode)
            qrcode = rdata.payurl;
          if (!qrcode)
            qrcode = rdata.urlscheme
          this.codeUrl = qrcode;
          this.dialogVisible = true;
        }
      });
    },
    getProduct() {
      this.axios.get('/product/list').then(resp => {
        let res = resp.data.data.datas.filter(item => item.name === '充值套餐' && item.edition !== 1)
        console.log(res)
        let dataArr = [];
        res.map(mapItem => {
          if (!dataArr || dataArr.length == 0) {
            dataArr.push({edition: mapItem.edition, list: [mapItem]})
          } else {
            let res = dataArr.some(item => {
              if (item.edition == mapItem.edition) {
                item.list.push(mapItem)
                return true
              }
            })
            if (!res) {
              dataArr.push({edition: mapItem.edition, list: [mapItem]})
            }
          }
        })
        this.dataArr = dataArr
        if (this.dataArr[this.current]) {
          this.product = JSON.parse(JSON.stringify(this.dataArr[this.current].list[this.currentLi]))
        }
      })
    },
    handleClose(done) {
      done();
    },
    opened() {
      this.makeQrcode(this.codeUrl);
      if (this.dialogVisible) {
        // 开始轮询订单状态
        this.pollingInterval = setInterval(this.checkOrderStatus, 2000); // 每2秒轮询一次
      }
    },
    closed() {
      document.getElementById("qrcode").innerHTML = "";
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    makeQrcode(codeUrl) {
      new Qrcode(this.$refs.qrcode, {
        width: 200,
        height: 200,
        colorDark: '#333',//二维码颜色
        colorLight: '#fff',//二维码背景颜色
        text: codeUrl,
        correctLevel: Qrcode.CorrectLevel.L//容错率,L/M/H
      })
    },
    async getUserData() {
      let data = {
        username: getUser()
      };
      await this.axios.post('/user/detail', qs.stringify(data), {
        headers: {
          "Jwt": getToken()
        }
      }).then(res => {
        this.userData = res.data.data
        const editionNumber = this.userData.edition - 2
        this.current = editionNumber < 0 ? 0 : editionNumber
        const currentDate = new Date();
        const expirationDate = new Date(this.userData.limittime)
        if (currentDate > expirationDate) {
          this.isHuiYuan = false
        } else {
          this.isHuiYuan = true
        }
      });
    }
  },
  mounted() {
    this.getProduct();
    this.getUserData();
  }
}
</script>

<style scoped lang="scss">
.content {
  li {
    border: 1px solid gray;
    margin-top: 20px;
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 5px;

    .price {
      font-size: 32px;
      flex: 1;
      text-align: center;
      color: #ee696c;
      font-weight: 700;

      &::before {
        content: '￥';
        font-size: 60%;
      }
    }

    .rightBox {
      height: 100%;
      flex: 4;
      padding-left: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;

      .date {
        font-weight: 500
      }
    }
  }

  .li-active {
    border: #ee696c 1px solid !important;
    -webkit-box-shadow: #ee696c 0 0 10px !important;
    -moz-box-shadow: #ee696c 0 0 10px !important;
    box-shadow: #ee696c 0 0 10px !important;
  }
}

.buy_money {
  text-align: center;
  color: #3586ff;
  margin-bottom: 20px;
}

.buy_money span:nth-child(1) {
  font-size: 16px;
}

.buy_money span:nth-child(2) {
  font-size: 16px;
}

.buy_money span:nth-child(3) {
  font-size: 30px;
  font-weight: 600;
  padding-right: 8px;
}

.main {
  background: #f2f3f5;
  height: auto;
  overflow-x: hidden;

  .box {
    max-width: 600px;
    min-height: calc(100vh - 108px);
    background: white;
    width: auto;
    margin: 0 auto;
    position: relative;
    padding-bottom: 40px;
  }

  .img {
    width: 100%;
    max-width: 600px;

    img {
      width: 100%;
    }
  }
}

.tab-contain {
  margin: 20px auto 0;
  width: 100%;
}

#tabs {
  overflow: hidden;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

#tabs li {
  float: left;
  margin: 0;
  width: 50%;
}

.topLi p {
  cursor: pointer;
  position: relative;
  padding: 10px 0;
  float: left;
  text-decoration: none;
  color: #000000;
  /*box-shadow: 0 2px 2px rgba(0, 0, 0, .4);*/
  width: 100%;
  text-align: center;
  font-weight: 500;
}

.botLi {
  cursor: pointer;
}

.current p {
  outline: 0;
  background: #fff;
  z-index: 4;
  border-bottom: #2d8eff 3px solid;
  color: #2d8eff !important;
  font-weight: 700 !important;
}

.sh_btn_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}

@media (max-width: 480px) {
  li a {
    font-size: 14px;
  }

  .tab-contain {
    padding: 1px 20px;
  }

  .content {
    padding: 0;
  }
}

@media (min-width: 481px) {
  li a {
    font-size: 18px;
  }

  .tab-contain {
    padding: 1px 0;
  }

  .content {
    padding: 0 80px;
  }
}

p {
  margin: 0;
}

.btn-primary {
  color: #FFF;
  background-color: #E74C3C;
  border-color: #E74C3C;
}
</style>